/** API route map: URLS.Controller.Rights */
export const Rights = {
      Name: 'Right/',
      GetAll: 'get-modulerights',
};
